const DAILY_KEY = 'hxd-daily-landing-date';
const MARKETING_HOME_KEY = 'hxd-marketing-home';

export function getLocalDateKey() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** User chose Home in the sub-nav — show marketing, not the daily redirect. */
export function markExplicitMarketingHome() {
  try {
    sessionStorage.setItem(MARKETING_HOME_KEY, '1');
  } catch {
    /* ignore */
  }
}

function consumeExplicitMarketingHome() {
  try {
    if (sessionStorage.getItem(MARKETING_HOME_KEY) !== '1') return false;
    sessionStorage.removeItem(MARKETING_HOME_KEY);
    return true;
  } catch {
    return false;
  }
}

/** First authenticated open of the calendar day (local time). */
export function hasOpenedBriefToday() {
  try {
    return localStorage.getItem(DAILY_KEY) === getLocalDateKey();
  } catch {
    return false;
  }
}

export function markOpenedBriefToday() {
  try {
    localStorage.setItem(DAILY_KEY, getLocalDateKey());
  } catch {
    /* ignore */
  }
}

/**
 * True when a signed-in user hitting `/` should be sent to today's brief.
 */
export function shouldRedirectAuthenticatedToToday() {
  if (consumeExplicitMarketingHome()) return false;
  return !hasOpenedBriefToday();
}
